// 时分秒的格式转换
function unitFormat(i) {
  let retStr = null
  if (i >= 0 && i < 10) retStr = "0" + i
  else retStr = "" + i
  return retStr
}

export const FormatSecondsOptions = {
  IGNORE_ZERO_HOUR: 1 << 1, // 不显示0小时
  IGNORE_ZERO_MINUTE: 1 << 2, // 不显示0分钟
  IGNORE_ZERO_PREFIX: 1 << 3, // 不显示前缀0
}

/**
 * 将秒数转换为时分秒
 * @param {int} second 秒数
 * @param {FormatSecondsOptions} options 枚举选项
 */
export function formatSeconds(oldSecond) {
  let second = parseInt(oldSecond)
  if (isNaN(second) || typeof second !== "number") {
    return oldSecond
  }

  let timeStr = ""

  if (second <= 0) {
    timeStr = "00:00:00"
  } else {
    let minute = Math.floor(second / 60)
    let hour = Math.floor(second / 3600)
    if (second < 60) {
      timeStr = "00:00:" + unitFormat(second)
    } else if (minute < 60) {
      second = second % 60
      timeStr = "00:" + unitFormat(minute) + ":" + unitFormat(second)
    } else if (hour < 24) {
      minute = Math.floor((second - hour * 3600) / 60)
      second = second - hour * 3600 - minute * 60
      timeStr = unitFormat(hour) + ":" + unitFormat(minute) + ":" + unitFormat(second)
    } else {
      // 数字 >= 3600 * 24 的时候
      let day = Math.floor(second / (3600 * 24))
      hour = Math.floor((second - day * 24 * 3600) / 3600)
      minute = Math.floor((second - day * 24 * 3600 - hour * 3600) / 60)
      second = second - day * 24 * 3600 - hour * 3600 - minute * 60
      timeStr = day + "天 " + unitFormat(hour) + ":" + unitFormat(minute) + ":" + unitFormat(second)
    }
  }
  return timeStr
}
